import {
    GET_VIEWS_LIST_SUCCESS,
    GET_VIEWS_LIST_FAILURE,

    GET_RECENT_VIEWS_SUCCESS,
    GET_RECENT_VIEWS_FAILURE,

    GET_VIEW_BY_ID_REQUEST,
    GET_VIEW_BY_ID_SUCCESS,
    GET_VIEW_BY_ID_FAILURE,

    CREATE_VIEW_SUCCESS,
    CREATE_VIEW_FAILURE,

    UPDATE_VIEW_SUCCESS,
    UPDATE_VIEW_FAILURE,

    DELETE_VIEW_SUCCESS,
    DELETE_VIEW_FAILURE,

    CLONE_VIEW_SUCCESS,
    CLONE_VIEW_FAILURE,

    RUN_VIEW_SUCCESS,
    RUN_VIEW_FAILURE,

    GET_VIEW_DATA_SUCCESS,
    GET_VIEW_DATA_FAILURE,

    GET_VIEW_HISTORY_SUCCESS,
    GET_VIEW_HISTORY_FAILURE,

    GET_USER_VIEW_PERMISSION_SUCCESS,
    GET_USER_VIEW_PERMISSION_FAILURE,

    GET_USER_VIEW_RESOURCE_PERMISSION_SUCCESS,
    GET_USER_VIEW_RESOURCE_PERMISSION_FAILURE,
} from "./actions";

const initialState = {
    getViewsListResult: {},
    viewsListResult: { Items: [] },
    getRecentViewsResult: {},
    recentViewsResult: { Items: [] },
    getViewByIdResult: {},
    viewDetail: null,
    createViewResult: {},
    updateViewResult: {},
    deleteViewResult: {},
    cloneViewResult: {},
    runViewResult: {},
    getViewDataResult: {},
    viewData: { Items: [] },
    getViewHistoryResult: {},
    viewHistory: { Items: [] },
    getUserViewPermissionResult: {},
    permission: null,
    getUserViewResourcePermissionResult: {},
    resourcePermission: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_VIEWS_LIST_SUCCESS:
            return {
                ...state,
                getViewsListResult: { success: true },
                viewsListResult: action.append
                    ? { ...action.payload, Items: [...state.viewsListResult.Items, ...(action.payload.Items || [])] }
                    : action.payload,
            };
        case GET_VIEWS_LIST_FAILURE:
            return {
                ...state,
                getViewsListResult: { success: false, ...action.payload.error },
            };

        case GET_RECENT_VIEWS_SUCCESS:
            return {
                ...state,
                getRecentViewsResult: { success: true },
                recentViewsResult: action.payload,
            };
        case GET_RECENT_VIEWS_FAILURE:
            return {
                ...state,
                getRecentViewsResult: { success: false, ...action.payload.error },
            };

        case GET_VIEW_BY_ID_REQUEST:
            return {
                ...state,
                getViewByIdResult: {},
                viewDetail: null,
                viewData: { Items: [] },
                viewHistory: { Items: [] },
            };
        case GET_VIEW_BY_ID_SUCCESS:
            return {
                ...state,
                getViewByIdResult: { success: true },
                viewDetail: action.payload.view,
            };
        case GET_VIEW_BY_ID_FAILURE:
            return {
                ...state,
                getViewByIdResult: { success: false, ...action.payload.error },
            };

        case CREATE_VIEW_SUCCESS:
            return {
                ...state,
                createViewResult: { success: true },
            };
        case CREATE_VIEW_FAILURE:
            return {
                ...state,
                createViewResult: { success: false, ...action.payload.error },
            };

        case UPDATE_VIEW_SUCCESS:
            return {
                ...state,
                updateViewResult: { success: true },
                viewDetail: action.payload.view,
            };
        case UPDATE_VIEW_FAILURE:
            return {
                ...state,
                updateViewResult: { success: false, ...action.payload.error },
            };

        case DELETE_VIEW_SUCCESS:
            return {
                ...state,
                deleteViewResult: { success: true },
                viewsListResult: {
                    ...state.viewsListResult,
                    Items: state.viewsListResult.Items.filter(v => v.viewId !== action.payload.viewId),
                },
            };
        case DELETE_VIEW_FAILURE:
            return {
                ...state,
                deleteViewResult: { success: false, ...action.payload.error },
            };

        case CLONE_VIEW_SUCCESS:
            return {
                ...state,
                cloneViewResult: { success: true, view: action.payload.view },
            };
        case CLONE_VIEW_FAILURE:
            return {
                ...state,
                cloneViewResult: { success: false, ...action.payload.error },
            };

        case RUN_VIEW_SUCCESS:
            return {
                ...state,
                runViewResult: { success: true },
            };
        case RUN_VIEW_FAILURE:
            return {
                ...state,
                runViewResult: { success: false, ...action.payload.error },
            };

        case GET_VIEW_DATA_SUCCESS:
            return {
                ...state,
                getViewDataResult: { success: true },
                viewData: action.append
                    ? { ...action.payload, Items: [...state.viewData.Items, ...action.payload.Items] }
                    : action.payload,
            };
        case GET_VIEW_DATA_FAILURE:
            return {
                ...state,
                getViewDataResult: { success: false, ...action.payload.error },
            };

        case GET_VIEW_HISTORY_SUCCESS:
            return {
                ...state,
                getViewHistoryResult: { success: true },
                viewHistory: action.payload,
            };
        case GET_VIEW_HISTORY_FAILURE:
            return {
                ...state,
                getViewHistoryResult: { success: false, ...action.payload.error },
            };

        case GET_USER_VIEW_PERMISSION_SUCCESS:
            return {
                ...state,
                getUserViewPermissionResult: { success: true },
                permission: action.payload.permission,
            };
        case GET_USER_VIEW_PERMISSION_FAILURE:
            return {
                ...state,
                getUserViewPermissionResult: { success: false, ...action.payload.error },
            };

        case GET_USER_VIEW_RESOURCE_PERMISSION_SUCCESS:
            return {
                ...state,
                getUserViewResourcePermissionResult: { success: true },
                resourcePermission: action.payload.permission,
            };
        case GET_USER_VIEW_RESOURCE_PERMISSION_FAILURE:
            return {
                ...state,
                getUserViewResourcePermissionResult: { success: false, ...action.payload.error },
                resourcePermission: null,
            };

        default:
            return state;
    }
};

export default reducer;
